import { render, staticRenderFns } from "./ReplyView.vue?vue&type=template&id=8d60fcb6"
import script from "./ReplyView.vue?vue&type=script&lang=js"
export * from "./ReplyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports